// extracted by mini-css-extract-plugin
export default {"tabBody":"style--tabBody--2a8f49","hidden":"style--hidden--35a0bc"};